import { render } from "./InvestmentAmountDesktop.vue?vue&type=template&id=166edbfc&scoped=true"
import script from "./InvestmentAmountDesktop.vue?vue&type=script&lang=js"
export * from "./InvestmentAmountDesktop.vue?vue&type=script&lang=js"

import "./InvestmentAmountDesktop.vue?vue&type=style&index=0&id=166edbfc&lang=css&scoped=true"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166edbfc"]])

export default __exports__